<template>
  <div>
        <div v-if="error" class="alert alert-warning text-center" role="alert">
          Please complete all required fields marked with (*)
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-6 col-lg-12">
            <div class="form-group">
              <label for="schoolName">Name of School *</label>
              <input @select="helpSection()" type="text" v-model="form.name" class="form-control" id="schoolName" name="schoolName">
            </div>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-6">
            <div class="form-group">
              <label for="attendedDate">Dates Attended</label>
              <input @select="helpSection()" type="text" v-model="form.date" placeholder="Example: 2018 - 2020" class="form-control" id="attendedDate" name="attendedDate">
            </div>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-6">
            <div class="form-group">
              <label for="degree">Date Accomplished</label>
              <input @select="helpSection()" type="text" v-model="form.date_accomplished" class="form-control" id="date_accomplished" name="date_accomplished">
            </div>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-6">
            <div class="form-group">
              <label for="degree">Degree and Major</label>
              <input @select="helpSection()" type="text" v-model="form.degree" class="form-control" id="degree" name="degree">
            </div>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-6">
            <div class="form-group">
              <label for="gpa">GPA</label>
              <input @select="helpSection()" type="text" v-model="form.gpa" class="form-control" id="gpa" name="gpa">
            </div>
          </div>
          
          <div class="col-sm-12 col-md-6 col-lg-12">
            <div class="form-group">
              <label for="honors">Academic Honors</label>
              <div class="float-right" v-if="honorsWordCount < 41">Word Count: {{ honorsWordCount }}</div>
              <div class="float-right text-danger" v-else>Word Count: {{ honorsWordCount }}</div>
              <div v-if="honorsWordCount > 40" class="text-primary float-left"><i class="fas fa-info-circle"></i> It's recommended to keep this field to 40 words or less.</div>
              <textarea @select="helpSection()" @input="wordCountHonors()" v-model="form.honors" class="form-control" placeholder="" id="honors" name="honors"></textarea>
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-12 text-center">
            <div class="form-group">
              <a href="" @select="helpSection()" @click.prevent="storeData()" class="btn btn-lg btn-secondary btn-block">Add Record <i class="far fa-hand-point-right"></i></a>
            </div>
          </div>
        </div>
  </div>
</template>

<script>
export default {
  name: 'educationHistory',
  components: {
  
  },
  props: ['employeerId'],
  
  data() {
    return {
      error: false,
      honorsWordCount: 0,
      form: {
        name: "",
        date: "",
        date_accomplished: "",
        degree: "",
        honors: "",
        gpa: "",
      }
    }
  },
  methods: {
    
    removeEducation(x) {
      this.$emit('removeEducation', x);
    },

    helpSection() {
      this.$emit('loadHelpSection', "education");
    },

    wordCountHonors() {
      var count = this.form.honors.trim().split(" ").length;
      this.honorsWordCount = count;
    },

    storeData() {
      if(!this.form.name) {
          this.error = true;
          return;
        }

      this.$emit('storeData', this.form);
      this.form.name = "";
      this.form.date = "";
      this.form.degree = "";
      this.form.gpa = "";
      this.form.date_accomplished = "";
      this.form.honors = "";
      this.honorsWordCount = 0;
      this.error = false;
    }
  }
}
</script>

<style>

</style>
